<template>
  <div class="page-manual-conatiner-wrap">
    <div class="page-manual">
      <h1>
        {{ $t("permission_configuration_management.smsLogin.UserManual") }}
      </h1>
      <div class="page-content">
        <div class="manual-wrap">
          <!-- <h2>
            {{
              $t("permission_configuration_management.smsLogin.QuickStartGuide")
            }}
          </h2> -->
          <ul>
            <li>
              <a @click="handlePrview">
                <span
                  >{{
                    $t(
                      "permission_configuration_management.smsLogin.TrialVersion"
                    )
                  }}
                </span>
                <Icon type="ios-cloud-download" />
              </a>
            </li>
            <!-- <li>
              <a @click="handlePrview">
                <span
                  >{{
                    $t(
                      "permission_configuration_management.smsLogin.OfficialEdition"
                    )
                  }}
                </span>
                <Icon type="ios-cloud-download" />
              </a>
            </li> -->
            <li>
              <!-- class="no-hover" -->
              <a @click="handlePrviewCompany">
                <span>企业版</span>
                <Icon type="ios-cloud-download" />
              </a>
              <!-- <div class="no-link-mask"></div> -->
              <!-- <div class="no-link-word">
                {{
                  $t("permission_configuration_management.smsLogin.ComingSoon")
                }}
              </div> -->
            </li>
          </ul>
        </div>
        <!-- <div class="manual-wrap admin-manual">
          <h2>
            {{ $t("permission_configuration_management.smsLogin.adminGuide") }}
          </h2>
          <ul>
            <li>
              <a @click="handlePrview">
                <span>{{
                  $t(
                    "permission_configuration_management.smsLogin.TrialVersion"
                  )
                }}</span>
                <Icon type="ios-cloud-download" />
              </a>
            </li>
            <li>
              <a @click="handlePrview">
                <span>{{
                  $t(
                    "permission_configuration_management.smsLogin.OfficialEdition"
                  )
                }}</span>
                <Icon type="ios-cloud-download" />
              </a>
            </li>
            <li>
              <a class="no-hover">
                <Icon type="ios-cloud-download" />
              </a>
              <div class="no-link-mask"></div>
              <div class="no-link-word">
                {{
                  $t("permission_configuration_management.smsLogin.ComingSoon")
                }}
              </div>
            </li>
          </ul>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pdfUrl: "/sme/static/pdf/御云者(Cloudeasy)试用版快速上手指南v3.2.pdf",
      CompanyPDFUrl: "/sme/static/pdf/御云者(CloudEasy)正式版用户手册v1.1.pptx"
    };
  },
  methods: {
    handlePrview() {
      window.open(this.pdfUrl);
    },
    handlePrviewCompany() {
      window.open(this.CompanyPDFUrl);
    }
  }
};
</script>

<style scoped="scoped">
.page-manual-conatiner-wrap {
  background-color: #2d3a4b;
  height: 100vh;
}
.page-manual {
  /* background: #fff; */
  text-align: center;
}
.page-manual h1 {
  font-size: 32px;
  padding-top: 95px;
  color: #efecec;
  font-weight: normal;
}
.page-content {
  width: 1100px;
  margin: 0 auto;
}
.page-content .manual-wrap {
  /* text-align: left; */
  margin: 150px 0 30px 0;
}

.page-content .manual-wrap h2 {
  text-align: left;
  font-size: 24px;
  color: #efecec;
  margin-bottom: 30px;
}
.page-content .manual-wrap ul {
  display: flex;
  justify-content: space-between;
}
.page-content .manual-wrap ul li {
  width: 350px;
  height: 150px;
  display: inline-block;
  text-align: center;
  line-height: 150px;
  margin-bottom: 80px;
  font-size: 28px;
  color: #555;
  position: relative;
  margin-right: 10px;
}
.page-content .manual-wrap ul li a {
  display: inline-block;
  width: 100%;
  height: 100%;
  background: #d9e9f9;
  color: #5b7f9f;
  border-radius: 8px;
}
.page-content .manual-wrap ul li a:hover {
  background-color: #d0e8ff;
  color: #659ccf;
  text-decoration: none;
}
.page-content .admin-manual ul li a:hover {
  background-color: #fff4dc;
  color: #b48f61;
  text-decoration: none;
}
.page-content .admin-manual ul li a {
  background-color: #faead1;
  color: #8e7755;
}
.page-content .manual-wrap ul li a i {
  font-size: 40px;
}
.page-content .manual-wrap ul li a.no-hover:hover {
  text-decoration: none;
  cursor: default;
}
.no-link-mask {
  display: inline-block;
  position: absolute;
  left: 0;
  top: 0;
  background-color: #fff;
  opacity: 0.6;
  filter: alpha(opacity=60);
  width: 350px;
  height: 150px;
  border-radius: 8px;
}
.no-link-word {
  display: inline-block;
  position: absolute;
  left: 0;
  top: 0;
  width: 350px;
  height: 150px;
  line-height: 150px;
  font-size: 18px;
  font-weight: bolder;
  color: #3975a0;
}
.page-content .admin-manual ul li .no-link-word {
  color: #966611;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/permissions_configuration_management/user/PageManual.vue